import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMuNjM5OSA3LjUyOTczQzIzLjE4OTkgNy4xODk3MyAxOC43MDk5IDMuNTI5NzMgMTEuOTk5OSAzLjUyOTczQzEwLjQ5OTkgMy41Mjk3MyA5LjEwOTg2IDMuNzE5NzMgNy44NDk4NiA0LjAwOTczTDE4LjE3OTkgMTQuMzI5N0wyMy42Mzk5IDcuNTI5NzNaTTMuMjY5ODYgMS45Njk3M0wxLjk5OTg2IDMuMjQ5NzNMNC4wNDk4NiA1LjMwOTczQzEuOTA5ODYgNi4yODk3MyAwLjU4OTg2MyA3LjM0OTczIDAuMzU5ODYzIDcuNTI5NzNMMTEuOTg5OSAyMi4wMTk3TDExLjk5OTkgMjIuMDI5N0wxMi4wMDk5IDIyLjAxOTdMMTUuOTA5OSAxNy4xNTk3TDE5LjIyOTkgMjAuNDc5N0wyMC40OTk5IDE5LjIwOTdMMy4yNjk4NiAxLjk2OTczWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiOff = createIcon('SignalWifiOff', [
  [
    'path',
    {
      d: 'M23.6399 7.52973C23.1899 7.18973 18.7099 3.52973 11.9999 3.52973C10.4999 3.52973 9.10986 3.71973 7.84986 4.00973L18.1799 14.3297L23.6399 7.52973ZM3.26986 1.96973L1.99986 3.24973L4.04986 5.30973C1.90986 6.28973 0.589863 7.34973 0.359863 7.52973L11.9899 22.0197L11.9999 22.0297L12.0099 22.0197L15.9099 17.1597L19.2299 20.4797L20.4999 19.2097L3.26986 1.96973Z',
      key: '1mqb5u',
    },
  ],
]);

export default SignalWifiOff;
